module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_13-5217947e0ae7f7f479442418cf88e96c.png";